<template>
<div class="register-box justify-content-center">
    <div class="register-box-body">
        <template v-if="token">
            <PasswordUpdateForm></PasswordUpdateForm>
        </template>
        <template v-else>
            <RequestPasswordResetForm></RequestPasswordResetForm>
        </template>
    </div>
</div>
</template>

<script>
    import RequestPasswordResetForm from './partials/RequestPasswordResetForm.vue';
    import PasswordUpdateForm from './partials/PasswordUpdateForm.vue';
    
    export default {
        name: 'PasswordReset',
        data() {
            return {
            }
        }
        ,computed:{
            token(){
                return this.$route.params.token;
            }
        }
        , components:{
            RequestPasswordResetForm,
            PasswordUpdateForm
        }
        , created() {

        }
        , mounted() {
//            console.log('Register.vue');
        }
        , methods: {

        }
    }
</script>